// extracted by mini-css-extract-plugin
export var barContainer = "_2i-0";
export var extraThin = "_2i-3";
export var fillBar = "_2i-6";
export var fillContainer = "_2i-4";
export var overflow = "_2i-8";
export var overflowContainer = "_2i-5";
export var regular = "_2i-7";
export var thick = "_2i-1";
export var thin = "_2i-2";